var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-primary btn-sm",class:_vm.$style.button,attrs:{"href":_vm.href},on:{"click":_vm.emitClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }